export default {
  data () {
    return {
      fields: [
        {
          prop: 'applicant_name',
          label: '申请人',
          width: 120,
        },
        {
          prop: 'department_name',
          label: '部门',
          minWidth: 120,
        },
        {
          prop: 'type',
          label: '付款类型',
          minWidth: 90,
          formatter: row => row.type === 4 ? '批量付款' : this.type[row.type],
        },
        {
          prop: 'desc',
          label: '付款说明',
          width: 100,
        },
        {
          prop: 'payment_company',
          label: '付款公司',
          minWidth: 90,
          formatter: row => this.paymentCompanys[row.payment_company],
        },
        {
          prop: 'apply_amount',
          label: '应付金额',
          minWidth: 90,
        },
        {
          prop: 'paid_amount_total',
          label: '实付金额',
          width: 153,
        },
        {
          prop: 'status',
          label: '付款状态',
          width: 123,
          formatter: (row) => { return this.status[row.status] || '-' },
        },
        {
          prop: 'review_user_name',
          label: '当前审批人',
          width: 153,
          formatter: this.formatterReviewUserName
        },
        {
          prop: 'created_at',
          label: '申请日期',
          width: 160,
        },
        {
          prop: 'paid_date',
          label: '付款日期',
          width: 153,
          formatter: this.formatterPaidDate
        },
        {
          prop: 'updated_at',
          label: '更新日期',
          width: 160,
        },
        {
          prop: 'write_off_status',
          label: '冲销状态',
          width: 80,
          formatter: this.formatterWriteOffStatus
        },
      ],
    }
  },
  computed: {
    ...Vuex.mapState({
      type: state => state.paymentManagerNew.type,
      status: state => state.paymentManagerNew.status,
    }),
  },
  methods: {
    formatterReviewUserName (row) {
      if (row.status === 1) {
        return row.first_approver_name
      } else if (row.status === 2) {
        return row.second_approver_name
      } else if (row.status === 3) {
        return row.third_approver_name
      } else if (row.status === 4) {
        return row.fourth_approver_name
      } else if (row.status === 5) {
        return '费用会计'
      } else if (row.status === 6) {
        return '财务经理'
      } else if (row.status === 13) {
        return row.department_approver_name
      } else if (row.status === 14) {
        return row.special_approver_name
      }
      return '-'
    },
    formatterPaidDate (row) {
      if (row.paid_date !== '0000-00-00 00:00:00') {
        return row.paid_date.substr(0, 10)
      }
      return '-'
    },
    formatterWriteOffStatus (row) {
      if (row.type !== 3 || ![8, 10].includes(row.status)) {
        return '-'
      }
      for (const key in this.writeOffStatus) {
        if (key * 1 === row.write_off_status * 1 && Object.hasOwnProperty.call(this.writeOffStatus, key)) {
          return this.writeOffStatus[key]
        }
      }
      return '-'
    },
  },
}



// WEBPACK FOOTER //
// ./src/views/payment-approval-new/payment-approval.mixins.js